import { render, staticRenderFns } from "./sql.vue?vue&type=template&id=051bf9c4&"
import script from "./sql.vue?vue&type=script&lang=js&"
export * from "./sql.vue?vue&type=script&lang=js&"
import style0 from "./sql.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports